import { create } from "apisauce";
import ResponseCode from "./ResponseCode";
import { ENVIRONMENT } from "../utils/Constant";

const BaseApi = create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    apikey: process.env.REACT_APP_API_KEY,
    "Company": process.env.REACT_APP_COMPANY,
  },
  timeout: Number(process.env.REACT_APP_TIME_OUT),
  withCredentials: true,
});

/**
 * Transformando el response para poner los errores generales
 *
 * @param response
 */
function transformResponse(response) {
  if (response.ok) {
    return;
  }

  if (ResponseCode[response.problem]) {
    response.data = {
      problem: ResponseCode[response.problem],
      originalError: response.originalError,
    };
    return;
  }

  response.data = {
    problem: ResponseCode.CONNECTION_ERROR,
    originalError: response.originalError,
  };
}

BaseApi.addRequestTransform((request) => {
  if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.development) {
    console.log(request)
  }
});

// Agregar interceptor para manejar el caso de "unauthorized"
BaseApi.addResponseTransform((response) => {
  if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.development) {
    console.log(response)
  }

  transformResponse(response);
});

export { BaseApi };